import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { restFetcher } from "~/api/fetchers";

export const INVITES_PENDING_ENDPOINT = "client-invites/pending";

const dashboardDataRefetchSettings = {
  staleTime: 10 * 1000, // Cache data for 10 seconds if refocusing window or returning to page
  keepPreviousData: true, // Keep previous data until the new data is fetched
  refetchOnWindowFocus: true, // refetch stale queries when the window regains focus
  refetchOnMount: true, // or the app programmatically returns to the dashboard
};

const inviteSchema = z.object({
  id: z.number(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string(),
});

export type Invite = z.infer<typeof inviteSchema>;

const invitesResponse = z.array(inviteSchema);

export type InvitesResponse = z.infer<typeof invitesResponse>;

export function usePendingInvitesQuery() {
  return useQuery({
    queryKey: [INVITES_PENDING_ENDPOINT],
    queryFn: async () => {
      const resp = await restFetcher<InvitesResponse>(`/v1/${INVITES_PENDING_ENDPOINT}`);
      return invitesResponse.parse(resp);
    },
    ...dashboardDataRefetchSettings,
  });
}

usePendingInvitesQuery.getKey = () => [INVITES_PENDING_ENDPOINT];

export const INVITES_REVIEW_ENDPOINT = "client-invites/review";

export function useReviewInvitesQuery() {
  return useQuery({
    queryKey: [INVITES_REVIEW_ENDPOINT],
    queryFn: async () => {
      const resp = await restFetcher<InvitesResponse>(`/v1/${INVITES_REVIEW_ENDPOINT}`);
      return invitesResponse.parse(resp);
    },
    ...dashboardDataRefetchSettings,
  });
}
